import React, { useState } from 'react';

import styles from "./Tabs.module.scss";
import { TabsTypes } from 'components/Tabs/types';
import ControlledTabs from '../ControlledTabs/ControlledTabs';

const UNCONTROLLED_MODE = 0;
const CONTROLLED_MODE = 1;

const getModeFromProps = (props: ITabsProps) => {
    return props.selected ? CONTROLLED_MODE : UNCONTROLLED_MODE;
}

interface ITabsProps {
    children: React.ReactElement,
    selected?: number,
    onSelect?: (index: number) => void,
    defaultIndex?: number,
    tabPanelClassname?: string,
    selectedTabPanelClassname?: string,
    tabListClassname?: string,
    tabClassname?: string,
    selectedTabClassname?: string,
    tabsContentWrapperClassname?: string,
    tabsWrapperClassname?: string
}

export interface TabsStatic {
    tabsRole: TabsTypes
}

const Tabs: React.FC<ITabsProps> & TabsStatic = (props) => {

    const {
        children,
        onSelect,
        selected,
        tabPanelClassname,
        selectedTabPanelClassname = styles.tabs__tabPanel_selected,
        tabListClassname = styles.tabs__tabList,
        tabClassname = styles.tabs__tabItem,
        selectedTabClassname = styles.tabs__tabItem_selected,
        tabsContentWrapperClassname = styles.tabs__contentWrapper,
        tabsWrapperClassname = styles.tabs__wrapper
    } = props;

    const [mode] = useState<number>(getModeFromProps(props));
    const [selectedTab, setSelectedTab] = useState(
        mode ? selected || 0 : 0
    );

    const handleSelect = (index: number) => {

        if(CONTROLLED_MODE && onSelect) {
            return onSelect(index);
        }

        if(UNCONTROLLED_MODE) {
            return setSelectedTab(index);
        }

        setSelectedTab(index);

    }

    const controlledTabsProps = {
        onSelect: handleSelect,
        selectedTab,
        tabPanelClassname: `${tabPanelClassname} ${styles.tabs__tabPanel}`,
        selectedTabPanelClassname,
        tabListClassname,
        tabClassname,
        selectedTabClassname,
        tabsContentWrapperClassname
    }

    return (
        <div className={tabsWrapperClassname}>
            <ControlledTabs {...controlledTabsProps}>
                {children}
            </ControlledTabs>
        </div>
    )
}
Tabs.tabsRole = TabsTypes.Tab;
export default Tabs;